import React, { Fragment } from 'react';
import Typography from "@material-ui/core/Typography";
import Card from '@material-ui/core/Card';
import CardContent from "@material-ui/core/CardContent";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: 'transparent',
    marginBottom: theme.spacing(2),
    borderRadius: 0,
    boxShadow: 'none',
    // border: '1px solid #eee'
  },
}));

const TitleBlock = ({ content , title}) => {
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      {title && <Typography gutterBottom variant="subtitle1">{title}</Typography>}
      <div dangerouslySetInnerHTML={{__html: content}} />
    </Card>
  )
};

export default TitleBlock;
